<template src="./detail.html"></template>

<script>

import JobService from 'Services/JobService';
import STATUS_CODE from 'Utilities/constant/statusCode';
import { GENDER, WORK, EDUCATION } from 'Utilities/constant/job';
import UserService from 'Services/UserService';

export default {
  data() {
    return {
      id: this.$route.params.id,
      job: {},
      first_name: null,
      last_name: null,
      email: null,
      line_phone: null,
      content_question: null,
      apply: 2,
    };
  },

  created() {
    this.listSlideBars();
  },

  methods: {
    listSlideBars() {
      JobService.showJob(this.id)
        .then((response) => {
          this.job = response.data;
        })
        .catch(() => {});
    },
    applyNow() {
      if (this.apply === 1) {
        this.apply = 2;
      } else {
        this.apply = 1;
      }
    },
    showConfirm() {
      const options = { title: this.$t('job.detail.title'), cancelLabel: this.$t('job.detail.cancel'), okLabel: this.$t('job.detail.confirm') };
      this.$dialogs.confirm(this.$t('job.detail.message'), options)
        .then(() => {
          this.create();
        });
    },
    create() {
      const params = this.parseParams();
      UserService.applyJob(params)
        .then(() => {
          this.$router.push({ name: 'job.show', params: 'id: this.id' });
          this.resetParams();
        })
        .catch((errors) => {
          if (errors.status === STATUS_CODE.UNPROCESSABLE_ENTITY) {
            this.$setValidationErrors(errors.status, errors.data);
          } else {
            this.message = 'Vui lòng thử lại';
          }
        });
    },

    parseTypeGender(type) {
      let text = '';
      if (localStorage.getItem('lang') === 'ja') {
        switch (type) {
          case GENDER.MALE:
            text = '男性';
            break;
          case GENDER.FEMALE:
            text = '女性';
            break;
          case GENDER.OTHER:
            text = 'その他の';
            break;
          case GENDER.ALL:
            text = '問わず';
            break;
          default:
            break;
        }
      }
      if (localStorage.getItem('lang') === 'en') {
        switch (type) {
          case GENDER.MALE:
            text = 'Nam';
            break;
          case GENDER.FEMALE:
            text = 'Nữ';
            break;
          case GENDER.OTHER:
            text = 'Khác';
            break;
          case GENDER.ALL:
            text = 'Không yêu cầu';
            break;
          default:
            break;
        }
      }

      return text;
    },

    parseTypeWork(type) {
      let text = '';
      if (localStorage.getItem('lang') === 'ja') {
        switch (type) {
          case WORK.NOT_REQUIREMENT:
            text = '男性';
            break;
          case WORK.ONETOTHREE:
            text = '女性';
            break;
          case WORK.THREETOFIVE:
            text = 'その他の';
            break;
          case WORK.FIVETOTEN:
            text = '問わず';
            break;
          case WORK.AFTERTEN:
            text = '問わず';
            break;
          default:
            break;
        }
      }
      if (localStorage.getItem('lang') === 'en') {
        switch (type) {
          case WORK.NOT_REQUIREMENT:
            text = 'Không yêu cầu';
            break;
          case WORK.ONETOTHREE:
            text = '1-3 năm';
            break;
          case WORK.THREETOFIVE:
            text = '3-5 năm';
            break;
          case WORK.FIVETOTEN:
            text = '5-10 năm';
            break;
          case WORK.AFTERTEN:
            text = '> 10 năm';
            break;
          default:
            break;
        }
      }

      return text;
    },

    parseTypeEducation(type) {
      let text = '';
      if (localStorage.getItem('lang') === 'ja') {
        switch (type) {
          case EDUCATION.HIGHT_SCHOOL:
            text = '一般者';
            break;
          case EDUCATION.INTERMEDIATE:
            text = '専門学校';
            break;
          case EDUCATION.COLLEGES:
            text = '短期大学';
            break;
          case EDUCATION.UNIVERSITY:
            text = '大学';
            break;
          case EDUCATION.AFTER_UNIVERSITY:
            text = '大学院';
            break;
          default:
            break;
        }
      }

      if (localStorage.getItem('lang') === 'en') {
        switch (type) {
          case EDUCATION.HIGHT_SCHOOL:
            text = 'Lao động phổ thông';
            break;
          case EDUCATION.INTERMEDIATE:
            text = 'Trung cấp';
            break;
          case EDUCATION.COLLEGES:
            text = 'Cao đẳng';
            break;
          case EDUCATION.UNIVERSITY:
            text = 'Đại học';
            break;
          case EDUCATION.AFTER_UNIVERSITY:
            text = 'Sau đại học';
            break;
          default:
            break;
        }
      }
      return text;
    },

    parseParams() {
      const params = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        line_phone: this.line_phone,
        content_question: this.content_question,
        job_id: this.id,
      };
      return params;
    },

    resetParams() {
      this.first_name = null;
      this.last_name = null;
      this.email = null;
      this.line_phone = null;
      this.content_question = null;
    },
  },
};
</script>
<style scoped>
pre {
     text-align: justify;
     white-space: pre-line;
}
</style>
